'use strict';

import moment from 'moment';
import randomstring from 'just.randomstring';

export default function CreateUserController($scope, $mdDialog, Auth, appConfig) {
  'ngInject';

  $scope.user = {};
  $scope.submitted = false;
  $scope.layoutTypes = appConfig.layoutTypes;

  $scope.accessList = [{ name: 'permanent', title: 'dauerhaft' }, { name: 'temporary', title: 'temporär' }];

  $scope.cancel = () => {
    $mdDialog.hide();
  };

  $scope.$watch('user.access', function(newValue, oldValue) {
    if(newValue === 'temporary' && !$scope.user.expiryDate) {
      let newDefaultDateTime = moment($scope.user.eventDate);
      newDefaultDateTime = newDefaultDateTime.add(-7, 'days');

      // Set the default time 23:59
      newDefaultDateTime.hour(23);
      newDefaultDateTime.minute(59);

      $scope.user.expiryDate = newDefaultDateTime.toDate();
    }
  });

  $scope.generatePassword = () => {
    const newPassword = randomstring(6);
    $scope.user.password = newPassword;
  };

  $scope.createUser = () => {
    const data = $scope.user;

    this.submitted = true;

    if($scope.form.$valid) {
      return Auth.createUser({
        name: data.name,
        email: data.email,
        password: data.password,
        access: data.access,
        expiryDate: data.expiryDate,
        isAdmin: data.isAdmin,
        isDemo: data.isDemo,
        layoutType: data.layoutType,
        eventDate: data.eventDate,
        eventId: data.eventId
      })
        .then(response => {
          // Account created, redirect to home
          $mdDialog.hide(response);
        })
        .catch(err => {
          err = err.data;
          this.errors = {};

          // Update validity of form fields that match the sequelize errors
          if(err.name) {
            angular.forEach(err.fields, (error, field) => {
              form[field].$setValidity('mongoose', false);
              this.errors[field] = err.message;
            });
          }
        });
    }
  };
}



// WEBPACK FOOTER //
// ./client/app/admin/create-user.controller.js